import React from 'react';
import './SelectedNodeHeaderMolecule.scss';

export interface NodePosition {
  x: number;
  y: number;
}

export interface SelectedNodeHeaderMoleculeProps {
  onCenter?: () => void;
  onClose: () => void;
  className?: string;
  nodePosition: NodePosition;
}

const SelectedNodeHeaderMolecule: React.FC<SelectedNodeHeaderMoleculeProps> = ({
  onCenter,
  onClose,
  className = '',
  nodePosition,
}) => {
  // Position header to the left of the node using exact viewport coordinates
  const headerStyle = {
    top: `${nodePosition.y}px`,
    left: `${nodePosition.x}px`,
  };

  return (
    <div className={`selected-node-header ${className}`} style={headerStyle}>
      <div className="selected-node-header__content">
        {onCenter && (
          <button
            className="selected-node-header__button selected-node-header__button--center"
            onClick={onCenter}
          >
            Center
          </button>
        )}
        <button
          className="selected-node-header__button selected-node-header__button--close"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default React.memo(SelectedNodeHeaderMolecule);